module.exports = __webpack_public_path__ + "biao18.png?d215581";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/biao/biao18.png
 ** module id = 53
 ** module chunks = 0
 **/